import * as THREE from "three";
import type { LoadedModel } from "./loader";
import type { SceneRefs } from "./scene";

/**
 * Hit-test the loaded model under the mouse, returning the catalog meshName
 * (or null if the hit isn't an orderable part).
 */
export class Picker {
  private raycaster = new THREE.Raycaster();
  private ndc = new THREE.Vector2();
  private meshToPart = new Map<THREE.Mesh, string>();
  private orderableMeshes: THREE.Mesh[] = [];

  constructor(
    private refs: SceneRefs,
    model: LoadedModel,
  ) {
    for (const [meshName, entry] of model.parts) {
      for (const m of entry.meshes) {
        this.meshToPart.set(m, meshName);
        this.orderableMeshes.push(m);
      }
    }
  }

  /** Convert a clientX/clientY pair (relative to the canvas) into a hit. */
  pick(clientX: number, clientY: number): string | null {
    const r = this.refs.canvas.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return null;
    this.ndc.x = ((clientX - r.left) / r.width) * 2 - 1;
    this.ndc.y = -((clientY - r.top) / r.height) * 2 + 1;
    this.raycaster.setFromCamera(this.ndc, this.refs.camera);
    const hits = this.raycaster.intersectObjects(this.orderableMeshes, false);
    if (hits.length === 0) return null;
    return this.meshToPart.get(hits[0].object as THREE.Mesh) ?? null;
  }
}
